import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_SET_PASSWORD: IntlKeyValuePair = {
    key: "setPassword",
    defaultValue: "Set Password",
    intlValue: "Set Password",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_RESET_PASSWORD: IntlKeyValuePair = {
    key: "resetPassword",
    defaultValue: "Reset Password",
    intlValue: "Reset Password",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_CHANGE_PASSWORD: IntlKeyValuePair = {
    key: "changePassword",
    defaultValue: "Change Password",
    intlValue: "Change Password",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_ENTER_NEW_PASSWORD: IntlKeyValuePair = {
    key: "enterNewPassword",
    defaultValue: "Enter your new password",
    intlValue: "Enter your new password",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_NEW_PASSWORD: IntlKeyValuePair = {
    key: "newPassword",
    defaultValue: "New Password",
    intlValue: "New Password",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_RESET_LINK_EXPIRED: IntlKeyValuePair = {
    key: "resetLinkExpired",
    defaultValue: "This reset link has expired.",
    intlValue: "This reset link has expired.",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_PASSWORD_RESET: IntlKeyValuePair = {
    key: "passwordReset",
    defaultValue: "Password Reset",
    intlValue: "Password Reset",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_LOGIN_WITH_NEW_PASSWORD: IntlKeyValuePair = {
    key: "loginWithNewPassword",
    defaultValue:
        "<0>Your password has been reset. You may now <1>login</1> with your new password.</0>",
    intlValue:
        "<0>Your password has been reset. You may now <1>login</1> with your new password.</0>",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_RESET_SUCCESSFUL: IntlKeyValuePair = {
    key: "resetSuccessful",
    defaultValue: "Password Successfully Reset",
    intlValue: "Password Successfully Reset",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_PASSWORD_RESET_REQUEST: IntlKeyValuePair = {
    key: "passwordResetRequest",
    defaultValue: "Password Reset Requested",
    intlValue: "Password Reset Requested",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_RESET_REQUESTED: IntlKeyValuePair = {
    key: "resetRequested",
    defaultValue: "Reset Requested",
    intlValue: "Reset Requested",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_RESET_REQUEST: IntlKeyValuePair = {
    key: "resetRequest",
    defaultValue: "Request a Password Reset",
    intlValue: "Request a Password Reset",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_RESET_SENT: IntlKeyValuePair = {
    key: "resetSent",
    defaultValue: "We've sent you an email with a link to reset your password.",
    intlValue: "We've sent you an email with a link to reset your password.",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_LOGIN_HERE: IntlKeyValuePair = {
    key: "loginHere",
    defaultValue: "Login here",
    intlValue: "Login here",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_KNOW_YOUR_PASSWORD: IntlKeyValuePair = {
    key: "knowYourPassword",
    defaultValue: "Know your password? ",
    intlValue: "Know your password? ",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_SEND_LINK: IntlKeyValuePair = {
    key: "sendLink",
    defaultValue: "Send Link",
    intlValue: "Send Link",
    namespace: IntlNamespaces.PASSWORD_RESET,
};

export const INTL_EMAIL: IntlKeyValuePair = {
    key: "email",
    defaultValue: "Email",
    intlValue: "Email",
    namespace: IntlNamespaces.PASSWORD_RESET,
};
